import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Form, Field } from "react-final-form";
import DatePicker from "react-datepicker";

import {
  FORM_FIELDS_INTEGRATION_AMAZON,
  API_URL,
  GET_ME,
  POST_ME,
  GET_COUNTRIES,
  CONTINENTS,
  GET_ALL_REGIONS,
  GET_ALL_MARKET_PLACES,
  POST_GET_INTEGRATIONS,
} from "../../../../constants";
import {
  CHECK_IF_REQUIRED,
  OBJECT_EMPTY,
  GET_TOKEN
} from "../../../../helpers";

import "./ProviderAmazon.css";

export const ProviderAmazon = (props) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [countries, setCountries] = useState({});
  // const [allRegions, setAllRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [fetchedMarketPlaces, setFetchedMarketPlaces] = useState([]);
  const [error, setError] = useState('');
  const [showCountryOfDispatch, setShowCountryOfDispatch] = useState(false);
  
  const [marketplaces, setMarketplaces] = useState([]);
  const [digitalGoodsValue, setDigitalGoodsValue] = useState('');
  const [countryOfDisaptch, setCountryOfDisaptch] = useState('');
  const [disableIfNoneSelected, setDisableIfNoneSelected] = useState(true);
  
  const [date, setDate] = useState('');
  const [sellerIdInput, setSellerIdInput] = useState('');
  const [cityInput, setCityInput] = useState('');
  const [addressInput, setAddressInput] = useState('');
  const [zipInput, setZipInput] = useState('');
  const [countryInput, setCountryInput] = useState('');

  const [mwsAuthToken, setMwsAuthToken] = useState('');
  const [disabledSubmit, setDisabledSubmit] = useState(true);
  const [showAdditionalData, setshowAdditionalData] = useState(false);

  // MIN 16 Months back to register at Amazon.
  const dateToday = new Date();
  dateToday.setMonth(dateToday.getMonth() - 16)

  // Get countries
  useEffect(() => {
    if (OBJECT_EMPTY(countries)) {
      fetch(API_URL + GET_COUNTRIES)
        .then((response) => response.json())
        .then((data) => setCountries(data));
    }
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if(marketplaces.length > 0 && digitalGoodsValue.length > 0 && (!showCountryOfDispatch || showCountryOfDispatch && countryOfDisaptch !== "")) {
      setDisableIfNoneSelected(false);
    } else {
      setDisableIfNoneSelected(true);
    }
  }, [marketplaces, digitalGoodsValue, countryOfDisaptch])

  useEffect(() => {
    if(date !== "" && sellerIdInput !== "" && mwsAuthToken !== "") {
      setDisabledSubmit(false);
    } else {
      setDisabledSubmit(true);
    }
  }, [date, sellerIdInput, mwsAuthToken])

  // Get Marketplace
  useEffect(() => {
    fetch(API_URL + GET_ALL_MARKET_PLACES)
      .then((response) => response.json())
      .then((data) => setFetchedMarketPlaces(data));

  // eslint-disable-next-line
  }, []);
  
  const onSubmit = async (values) => {
    await fetch(API_URL + POST_GET_INTEGRATIONS, {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: JSON.stringify({
        ...values,
        amazon_marketplaces: marketplaces,
        historical_date: date,
        integration_type: props.providerType,
        country_of_disaptch: countryOfDisaptch,
        seller_id: sellerIdInput,
        amazon_mws_auth_token: mwsAuthToken,
        city_input: cityInput,
        country_input: countryInput,
        zip_input: zipInput,
        address_input: addressInput

      }),
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.error !== undefined) {
        setError(response.error);
      } else {
        setCurrentStep(3)
      }
    });
  };

  const setShowAdditionalData = (e) => {
    if (e.target.checked) {
      console.log(e.target.checked);
      setshowAdditionalData(true);
    } else {
      setshowAdditionalData(false);

    }
  }

  const getMarketPlaces = () => {
    if (fetchedMarketPlaces.length > 0 ) {
      return fetchedMarketPlaces.map((item, index) => {
        return (
          <div className="marketplace-checkbox" key={index + item.value}>
            <label>
              <input
                name={item.name}
                component="input"
                type="checkbox"
                value={item.value}
                onClick={(e) => {
                  if (marketplaces.includes(e.target.value)) {
                    let arrayToUpdate = marketplaces;
                    arrayToUpdate.splice(marketplaces.indexOf(e.target.value), 1);

                    return setMarketplaces([...arrayToUpdate]);
                  } else {
                    setMarketplaces([...marketplaces, e.target.value])
                  }
                }}
              />
              {item.name}
              {item.img && (
                <img src={item.img} className="flag-icon-img" alt={item.name} />
              )}
            </label>
          </div>
        );
      })
    } else {
      return <i>No marketplaces available</i>
    }
  };

  const SpecificValueSelected = (e) => {
    if (e.target.name === FORM_FIELDS_INTEGRATION_AMAZON.amazon_country_of_dispatch.name || (e.target.name === FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods.name && (e.target.value === "2001" || e.target.value === "2002"))) {
      setShowCountryOfDispatch(true)
    } else if ((e.target.name === FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods.name && !(e.target.value === "2001" || e.target.value === "2002"))) {
      return (setShowCountryOfDispatch(false), setCountryOfDisaptch(''))
    } else {
      return;
    }
  };

  return (
    <div className="ProviderAmazon">
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} noValidate>
              {error.length > 0 && <div className="Provider__error">{error}</div> }
              
              {currentStep === 1 && (
                <>
                  <h2>Let's start with your Amazon Integration (3 minutes step)</h2>
                  {/* <h1>Describe your product</h1> */}

                  <div className="form-wrapper">
                    <div className="product-description flex">
                      {/* <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods.name}>
                        <Field
                          name={FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods.name}
                          key={FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods.name}
                        >
                          {({ input, meta }) => {
                            const { onChange } = input;

                            const mergedOnChange = (e) => {
                              SpecificValueSelected(e);
                              setDigitalGoodsValue(e.target.value);
                              onChange(e);
                            };

                            const newInput = { ...input, onChange: mergedOnChange };

                            return (
                              <select {...newInput} className="default-input" value={digitalGoodsValue}>
                                <option disabled value="">
                                  {FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods.placeholder}
                                </option>

                                {FORM_FIELDS_INTEGRATION_AMAZON.digitalGoods["content"].map((item, i) => {
                                  return (
                                    <option value={item.value} key={item.value + i}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </select>
                            );
                          }}
                        </Field>
                      </div> */}
                      
                      {showCountryOfDispatch && (
                        <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.amazon_country_of_dispatch.name}>
                          <Field
                            name={FORM_FIELDS_INTEGRATION_AMAZON.amazon_country_of_dispatch.name}
                          >
                            {({ input }) => {
                              const { onChange } = input;
                              const mergedOnChange = (e) => onChange(e);
                              const newInput = { ...input, onChange: mergedOnChange };

                              return (
                                <select {...newInput} className={"default-input"} onChange={(e) => setCountryOfDisaptch(e.target.value)} value={countryOfDisaptch}>

                                  {/* Placeholder */}
                                  <option disabled required value="" key={1}>
                                    Default country of dispatch
                                  </option>

                                  {/* Values */}
                                  {Object.entries(countries).map(
                                    ([item, continentValue]) => {
                                      return (
                                        <optgroup label={CONTINENTS[item]} key={item}>
                                          {continentValue.map((country) => (
                                            <option value={country.id} key={country.id}>
                                              {country.name}
                                            </option>
                                          ))}
                                        </optgroup>
                                      );
                                    }
                                  )}
                                </select>
                              );
                            }}
                          </Field>
                        </div>
                      )}
                    </div>

                    <div className="product-marketplaces">
                      <h1>Select your marketplaces</h1>

                      <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.amazon_marketplaces.name}>
                        {getMarketPlaces()}
                      </div>

                       <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.amazon_fba.name}>
                        {/*<p className="title">{FORM_FIELDS_INTEGRATION_AMAZON.amazon_fba.title}</p>*/}
                        <Field
                          name={FORM_FIELDS_INTEGRATION_AMAZON.amazon_fba.name}
                          component="input"
                          type="checkbox"
                          value={FORM_FIELDS_INTEGRATION_AMAZON.amazon_fba.value}
                          onClick={(e) => setShowAdditionalData(e)}
                        />
                        Are you using self delivery service (Not FBA only)?
                      </div>
                    </div>
                    <div className="product-marketplaces">
                      <div className={showAdditionalData ? "amazon-data-fields" : " amazon-data-fields hidden"}>
                      <h1>Please fill your warehouse address</h1>
                    <table className="amazon-info" ><tr><td>


                      <p className="title">Select country</p>
                      <select className="default-input" 
                                                onChange={(e) => setCountryInput(e.target.value)}
                                                >
                                <option value="">
                                 Select
                                </option>
                    {Object.entries(countries).map(
                      ([item, continentValue]) => {
                        return (
                          <optgroup label={CONTINENTS[item]} key={item}>
                            {continentValue.map((country) => (
                              <option value={country.id} key={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </optgroup>
                        );
                      }
                    )}
                  </select>


                    </td>

                    <td>

                      <p className="title">City / State</p>
                      <input
                          className={"default-input"}
                          name={FORM_FIELDS_INTEGRATION_AMAZON.amazon_city.name}
                          type="text"
                          key={FORM_FIELDS_INTEGRATION_AMAZON.amazon_city.name}
                          placeholder={FORM_FIELDS_INTEGRATION_AMAZON.amazon_city.placeholder}
                          component="input"
                          autoComplete="off"
                          value={cityInput}

                          onChange={(e) => setCityInput(e.target.value)}
                        />


                    </td>


                    <td>


                      <p className="title">Address</p>
                      <input
                          className={"default-input"}
                          name={FORM_FIELDS_INTEGRATION_AMAZON.amazon_address.name}
                          type="text"
                          key={FORM_FIELDS_INTEGRATION_AMAZON.amazon_address.name}
                          placeholder={FORM_FIELDS_INTEGRATION_AMAZON.amazon_address.placeholder}
                          component="input"
                          autoComplete="off"
                          value={addressInput}
                          onChange={(e) => setAddressInput(e.target.value)}
                        />


                    </td>



                    <td>


                      <p className="title">Zip / Postal code</p>
                      <input
                          className={"default-input"}
                          name="State"
                          type="text"
                          key={FORM_FIELDS_INTEGRATION_AMAZON.amazon_zip.name}
                          placeholder={FORM_FIELDS_INTEGRATION_AMAZON.amazon_zip.placeholder}
                          component="input"
                          autoComplete="off"
                          value={zipInput}
                          onChange={(e) => setZipInput(e.target.value)}
                        />


                    </td>
                    
                    </tr>
                    </table>
                    </div>
                    </div>

                    <div className="submit-first-step">
                      <button
                        type="button"
                        className="purple-button"
                        onClick={() => setCurrentStep(2)}
                        disabled={(showAdditionalData && (zipInput === "" || cityInput === "" || addressInput === "" || countryInput === "" )) ? true : false }
                      >
                        proceed
                      </button>
                    </div>
                  </div>
                </>
              )}

              {/* Text */}
              {currentStep === 2 && (
                <>
                  <h2>You almost done, just one step left</h2>
                  {/* <h1>Describe your product</h1> */}
  
                  <div className="form-wrapper flex-space-between">
                  
                    <div className="Provider__left">
                      <h1 className="integrate_step_name">1. Authorize a Developer</h1>

                      <div className="integrate_step_descriptions">
                        <p>1. Go to "settings" {`>`} "user permissions" in your Amazon seller account.</p>
                        <p>2. Under Third-party developers and apps click the "Visit Manage your Apps" button.</p>
                        <p>3. Then click Authorize a Developer.</p>
                        <p>4. In the Developer name text box, enter the name of the application developer that you are authorizing. Developer name: <b className="purple-bck">1StopVat</b></p>
                        <p>5. In the Developer ID text box, enter the Developer ID provided by your application developer: <b className="purple-bck">8899-5073-2979</b></p>
                        <p>6. Accept the settings and continue.</p>
                        <p>7. You can view your Seller ID and MWS Authentication Token on this page. Copy and paste them to a form in "Step 2".</p>
                      </div>

                      {/* <h4>Need Help?</h4>
                      <Link></Link> */}

                      {/* <a className="Provider__download-link" href='#'>
                        Download detailed instruction (PDF)
                      </a> */}
                    </div>

                    <div className="Provider__right">
                      <h1 className="integrate_step_name">2. Add your account details</h1>

                      <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.seller_id.name}>
                        <input
                          className={"default-input"}
                          name={FORM_FIELDS_INTEGRATION_AMAZON.seller_id.name}
                          type="text"
                          key={FORM_FIELDS_INTEGRATION_AMAZON.seller_id.name}
                          placeholder={FORM_FIELDS_INTEGRATION_AMAZON.seller_id.title}
                          component="input"
                          autoComplete="off"
                          value={sellerIdInput}
                          onChange={(e) => setSellerIdInput(e.target.value)}
                        />
                      </div>

                      <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.amazon_mws_auth_token.name}>
                        <input 
                          className={"default-input"}
                          name={FORM_FIELDS_INTEGRATION_AMAZON.amazon_mws_auth_token.name}
                          type="text"
                          key={FORM_FIELDS_INTEGRATION_AMAZON.amazon_mws_auth_token.name}
                          placeholder={FORM_FIELDS_INTEGRATION_AMAZON.amazon_mws_auth_token.title}
                          component="input"
                          autoComplete="off"
                          onChange={(e) => setMwsAuthToken(e.target.value)}
                          value={mwsAuthToken}
                        />
                      </div>

                      <div className={"field-item " + FORM_FIELDS_INTEGRATION_AMAZON.historical_date.name}>
                        <DatePicker
                          autoComplete="off"
                          name={FORM_FIELDS_INTEGRATION_AMAZON.historical_date.name}
                          selected={date}
                          onChange={(newDate) => setDate(newDate)}
                          placeholderText={FORM_FIELDS_INTEGRATION_AMAZON.historical_date.title}
                          className="default-input"
                          dateFormat="yyyy-MM"
                          showMonthYearPicker
                          minDate={dateToday}
                        />
                      </div>
                    
                      {/* Submit */}
                      <div className="modal_button flex">
                        <button
                          type="submit"
                          className="purple-button"
                          disabled={disabledSubmit}
                        >
                            Add Integration
                        </button>
                      </div>
                    </div>
                    
                  </div>
                </>
              )}

              {/* Success */}
              {currentStep === 3 && (
                <div className="Provider__success">
                  <Redirect to="/dashboard/integrations"/>
                </div>
              )}
            </form>
          )}
        />
    </div>
  )
};
